var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBritain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_483_31634)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1967,
    height: 24.1967,
    transform: "translate(0.266602 0.533203)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.365 24.7299C19.0467 24.7299 24.4633 19.3133 24.4633 12.6316C24.4633 5.94982 19.0467 0.533203 12.365 0.533203C5.68322 0.533203 0.266602 5.94982 0.266602 12.6316C0.266602 19.3133 5.68322 24.7299 12.365 24.7299Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.76753 5.26562C1.81719 6.50207 1.1006 7.92717 0.68335 9.47533H6.97723L2.76753 5.26562Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0465 9.47528C23.6292 7.92717 22.9126 6.50207 21.9623 5.26562L17.7527 9.47528H24.0465Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.68335 15.7871C1.10065 17.3352 1.81724 18.7603 2.76753 19.9967L6.97709 15.7871H0.68335Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7307 3.03344C18.4942 2.08311 17.0692 1.36652 15.521 0.949219V7.24305L19.7307 3.03344Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99927 22.2271C6.23571 23.1775 7.66081 23.8941 9.20893 24.3114V18.0176L4.99927 22.2271Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20888 0.949219C7.66076 1.36652 6.23566 2.08311 4.99927 3.0334L9.20888 7.24301V0.949219Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.521 24.3114C17.0691 23.8941 18.4942 23.1775 19.7306 22.2272L15.521 18.0176V24.3114Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7527 15.7871L21.9623 19.9968C22.9126 18.7604 23.6292 17.3352 24.0465 15.7871H17.7527Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3609 11.0535H13.9431H13.943V0.635614C13.4264 0.568364 12.8998 0.533203 12.365 0.533203C11.83 0.533203 11.3035 0.568364 10.7869 0.635614V11.0534V11.0535H0.369012C0.301762 11.5701 0.266602 12.0967 0.266602 12.6316C0.266602 13.1665 0.301762 13.693 0.369012 14.2096H10.7868H10.7869V24.6275C11.3035 24.6947 11.83 24.7299 12.365 24.7299C12.8998 24.7299 13.4264 24.6948 13.943 24.6275V14.2097V14.2096H24.3609C24.4281 13.693 24.4633 13.1665 24.4633 12.6316C24.4633 12.0967 24.4281 11.5701 24.3609 11.0535Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.521 15.7872L20.9197 21.1859C21.168 20.9376 21.4049 20.6781 21.6309 20.4092L17.0088 15.7871H15.521V15.7872Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2088 15.7871H9.20871L3.81006 21.1858C4.05826 21.4341 4.31776 21.6709 4.58676 21.8969L9.2088 17.2748V15.7871Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20873 9.47501V9.47492L3.81003 4.07617C3.56173 4.32438 3.32487 4.58388 3.09888 4.85288L7.72097 9.47497H9.20873V9.47501Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.521 9.47514L20.9197 4.07634C20.6715 3.82804 20.412 3.59118 20.143 3.36523L15.521 7.98732V9.47514Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_483_31634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1967,
    height: 24.1967,
    fill: "white",
    transform: "translate(0.266602 0.533203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBritain);
export default __webpack_public_path__ + "static/media/Britain.bf1349bae8243523686d45277bb6a8e6.svg";
export { ForwardRef as ReactComponent };